module.exports = __webpack_public_path__ + "img/cm-rezistenta-prin-colind-2.c8ff1135.jpg";